import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const UserNameEditActionSheetI18n = {
	[ELocaleCode.RU_RU]: {
		save: 'Сохранить',
	},
	[ELocaleCode.EN_US]: {
		save: 'Save',
	},
};
